module.exports = __webpack_public_path__ + "img/kr-product-final-card1-img1.99637b2.png";